<template>
  <div class="pay-select-summ-hid" v-if="!this.show">
    <v-form class="pay-select-summ" @submit="onSelectAmount" ref="form" validate-on-mount v-slot="{ meta }">
      <div class="pay-select-summ-caption">Сумма:</div>
      <div class="pay-select-summ-items">
        <template v-for="elem in this.suggestedValues" :key="elem">
          <SuggestedValue :value="elem" :selected="amount" v-on:chooseValue="val => this.choseValue(val)" />
        </template>
      </div>

      <div class="field-block">
        <v-field
          name="amount"
          v-model="amount"
          type="text"
          class="suminput"
          :rules="minMax"
          mode="aggressive"
          placeholder="0"
          maxlength="7"
          v-on:keypress="numbersOnly"
        />
        <div class="rub-static"><span>&#8381;</span></div>
        <div class="pm-block">
          <div class="pm-block-btn">
            <div class="plus" @click="inc(500)">+</div>
            <div class="minus" @click="inc(-500)">-</div>
          </div>
        </div>
        <error-message name="amount" />
      </div>

      <button class="pay-order-btn" type="submit" :disabled="!meta.valid || this.isLoading">Пополнить</button>
    </v-form>
  </div>

  <input-card-data
    v-if="this.show"
    v-on:closeModal="this.show = false"
    :amount="amount"
    :provider="provider.provider"
  />
</template>

<script>
import { useI18n } from 'vue-i18n'
import { ErrorMessage, Field, Form } from 'vee-validate'
import { SEND_PAYMENT } from '@/store/actions.type'
import { minMaxValidation } from '@/utils'
import { toast } from 'vue3-toastify'
import SuggestedValue from '@/components/cashdesk/TopUp/components/SuggestedValue.vue'
import InputCardData from '@/components/cashdesk/TopUp/Card/InputCardData.vue'

export default {
  name: 'CardController',
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
  components: {
    InputCardData,
    SuggestedValue,
    VForm: Form,
    VField: Field,
    ErrorMessage,
  },
  setup() {
    const { t, n } = useI18n()
    return { t, n }
  },
  data() {
    return {
      amount: null,
      isLoading: false,
      show: false,
      suggestedValues: [],
      card: {},
    }
  },
  mounted() {
    this.suggestedValues = this.provider?.suggestedValues
  },
  watch: {
    provider: function () {
      this.amount = null
      this.$refs.form.resetField('amount', null)
    },
  },
  computed: {},
  methods: {
    choseValue(value) {
      this.amount = value
      this.$refs.form.setFieldValue('amount', value, true)
    },
    minMax(value) {
      return minMaxValidation(value, this.provider)
    },
    inc(amount) {
      this.amount = parseFloat(this.amount || '0') + amount
      if (this.amount < this.provider?.min) {
        this.amount = this.provider?.min
      } else if (this.amount > this.provider?.max) {
        this.amount = this.provider?.max
      }
    },
    providerName() {
      return this.provider.provider
    },
    onSelectAmount() {
      this.show = true
    },

    //Только цифры в input
    numbersOnly(evt) {
      evt = evt ? evt : window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
